export type DividerVariant = 'grey' | 'dark'
